import script from "./CRM05_007INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM05_007INS.vue?vue&type=script&setup=true&lang=js"

import "./CRM05_007INS.vue?vue&type=style&index=0&id=8112d05c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8112d05c"]])

export default __exports__